import { FC } from 'react'
import { useHistory } from 'react-router'

import { useActionModalContext } from 'backoffice/components/DropRequests/Modals/ConfirmationModal/ActionModalContext'
import { Petition } from 'backoffice/components/DropRequests/usePetitionsQuery'
import { Actions, Status } from './types/types'
import { ROUTES } from 'lib/constants'

// Assets
import { ReactComponent as IconEdit } from 'images/icons/icon-edit.svg'
import { ReactComponent as IconApprove } from 'images/icons/icon-approve.svg'
import { ReactComponent as IconFlag } from 'images/icons/icon-flag.svg'
import { ReactComponent as IconReject } from 'images/icons/icon-reject.svg'

import styles from './ActionsMenu.module.scss'

const ICON_SIZE = 20

type ActionsMenuProps = {
  petition: Petition
}

export const MenuActionsPerStatus = [
  { status: Status.APPROVED, actions: [Actions.EDIT] },
  { status: Status.FLAGGED, actions: [Actions.APPROVE, Actions.REJECT, Actions.EDIT] },
  { status: Status.REJECTED, actions: [Actions.EDIT] },
  { status: Status.PENDING, actions: [Actions.APPROVE, Actions.FLAG, Actions.REJECT, Actions.EDIT] },
]

const ActionsMenu: FC<ActionsMenuProps> = (props) => {
  // Props
  const { petition } = props
  const { setActionModal } = useActionModalContext()
  const history = useHistory()

  // Handlers
  const handleClick = (value: Actions) => {
    if (value === Actions.EDIT) {
      history.push(`${ROUTES.event.path}${petition.drop.fancy_id}`)
    } else {
      setActionModal({ action: value, petition })
    }
  }

  const getActionDataFromStatus = (status: string) => {
    let actionMenuData

    switch (status) {
      case Actions.APPROVE:
        actionMenuData = {
          action: Actions.APPROVE,
          icon: <IconApprove width={ICON_SIZE} height={ICON_SIZE} />,
          text: 'Approve',
        }
        break
      case Actions.FLAG:
        actionMenuData = {
          action: Actions.FLAG,
          icon: <IconFlag width={ICON_SIZE} height={ICON_SIZE} />,
          text: 'Flag',
        }
        break
      case Actions.REJECT:
        actionMenuData = {
          action: Actions.REJECT,
          icon: <IconReject width={ICON_SIZE} height={ICON_SIZE} />,
          text: 'Reject',
        }
        break
      default:
        actionMenuData = {
          action: Actions.EDIT,
          icon: <IconEdit width={ICON_SIZE} height={ICON_SIZE} />,
          text: 'Edit Drop',
        }
        break
    }

    return actionMenuData
  }

  const availableActions = MenuActionsPerStatus.find((action) => action.status === petition.status)?.actions
  const menuOptions = availableActions?.map((action) => getActionDataFromStatus(action))

  return (
    <div className={styles.container}>
      <div className={styles.menu} data-test-id="actions_menu">
        {menuOptions?.map((option) => (
          <button
            type="button"
            className={styles.button}
            key={option.action}
            onClick={() => handleClick(option.action)}
            data-test-id={`actions_menu_button_${option.action}`}
          >
            <div className={styles.buttonContent}>
              {option.icon}
              <label data-test-id={`actions_menu_label_${option.action}`}>{option.text}</label>
            </div>
          </button>
        ))}
      </div>
    </div>
  )
}

export default ActionsMenu
